document.addEventListener('DOMContentLoaded', function () {
  const productLinks = document.querySelectorAll('.product-link');
  const modal = document.getElementById('quick-view-modal');
  const closeModal = document.getElementById('close-modal');

  const modalImage = document.getElementById('modal-product-image');
  const modalTitle = document.getElementById('modal-product-title');
  const modalPrice = document.getElementById('modal-product-price');
  const modalDescription = document.getElementById('modal-product-description');
  const addToCartButton = document.getElementById('add-to-cart');
  const soldOutButton = document.getElementById('sold-out-btn');
  const shippingInfo = document.getElementById('shipping-info');

  let selectedVariantId = null; // To store the variant ID of the product

  productLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const productHandle = this.getAttribute('data-handle');

      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(data => {
          modalImage.src = data.featured_image;
          modalTitle.textContent = data.title;
          modalPrice.textContent = `€${(data.price / 100).toFixed(2)}`;
          modalDescription.innerHTML = data.description;

          const availableVariant = data.variants.find(variant => variant.available);
          if (availableVariant) {
            selectedVariantId = availableVariant.id;
            addToCartButton.style.display = 'inline-block';
            soldOutButton.style.display = 'none';
            shippingInfo.style.display = 'block';
          } else {
            selectedVariantId = null;
            addToCartButton.style.display = 'none';
            soldOutButton.style.display = 'inline-block';
            shippingInfo.style.display = 'none';
          }

          modal.style.display = 'flex';
        })
        .catch(error => console.error('Error fetching product data:', error));
    });
  });

  addToCartButton.addEventListener('click', function () {
  if (!selectedVariantId) {
    alert('No variant selected for adding to cart.');
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: selectedVariantId,
      quantity: 1
    })
  })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add product to cart.');
      return response.json();
    })
    .then(data => {
      // Redirect to the cart page
      window.location.href = '/cart';
    })
    .catch(error => console.error('Error adding product to cart:', error));
});


  closeModal.addEventListener('click', function () {
    modal.style.display = 'none';
  });

  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });
});